// api/gcpCerts/getAllCerts.ts
import { GcpCert } from "../../types/gcpCert";

export type GetAllCertsResponse = {
  statusCode: number;
  body: GcpCert[];
};

const getAllCerts = async (): Promise<GetAllCertsResponse> => {
  const response = await fetch("/api/gcp-certs"); // replace with your endpoint

  if (!response.ok) {
    throw new Error(`Error fetching GCP Certs: ${response.status}`);
  }

  const data = await response.json();
  return data as GetAllCertsResponse; // explicitly type it
};

export default getAllCerts;